import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ActivityLogsHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/activity'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'activity_logs_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'activity_logs_list',
          meta: {
            permissions: ['administrator'],
          },
          component: ActivityLogsHome,
        },
      ],
    },
  ],
};
